/**
 * Created by Vladislav
 */
var NewClientDeterminationController = (function () {
    function NewClientDeterminationController(topic, $state, settings, $stateParams, DTS, socket, $scope, env, Dialog, moment) {
        var _this = this;
        this.topic = topic;
        this.$state = $state;
        this.settings = settings;
        this.$stateParams = $stateParams;
        this.DTS = DTS;
        this.socket = socket;
        this.$scope = $scope;
        this.env = env;
        this.Dialog = Dialog;
        this.moment = moment;
        this.comp = 'nc';
        this.lock = true;
        this.desArray = ['IBM-Led', 'BP-Led', 'Co-Led', 'Unassigned'];
        this.enableSection = true;
        this.isResetting = false;
        this.showThumb = true;
        this.processing = false;
        this.ncEndData = '';
        this.OPP_VERSION_3 = 3;
        this.getNewUIInfo = {
            NC: _.get(this.topic.checksData.result, 'NC', {}),
            uiVersion: _.get(this.topic.checksData, 'uiVersion', 1)
        };
        this.newClient = {};
        this.errorCheckerInput = false;
        this.socket.forward('topic.search.result', this.$scope);
        this.$scope.$on('socket:topic.search.result', function (event, data) {
            _this.processing = false;
        });
        this.visible = false;
        this.filterDisplay = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            // If the topic has been updated from the server...check if this component is part of
            // what was changed
            if (data.indexOf(_this.comp) > -1) {
                // HACK... if topic is updated and customer designation is IBM-Led
                // update the nc edit options accordingly... this is out-of-scope of the 10k
                // Sweet baby jesus and the orphans!!
                if (_this.topic.topic.customerDesignation === 'IBM-Led') {
                    _this.topic.editableComponents.nc = { editable: false, editMode: false, socket: 'Not Editable' };
                }
                else {
                    _this.topic.editableComponents.nc = { editable: true, editMode: false, socket: '' };
                }
                _this.edit = _this.topic.editableComponents.nc;
            }
            _this.ncEndData = _this.getNewClientApplicabilityEndData();
        });
    }
    NewClientDeterminationController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
        this.ncEndData = this.getNewClientApplicabilityEndData();
    };
    NewClientDeterminationController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    NewClientDeterminationController.prototype.isButtonDisabled = function () {
        return this.topic.checkNewClientEditMode(this.comp);
    };
    NewClientDeterminationController.prototype.toggleFilter = function () {
        this.filterDisplay = !this.filterDisplay;
        if (!this.filterDisplay) {
            this.newClient.country = undefined;
            this.newClient.cmrNum = undefined;
            this.newClient.fuzzySearch = undefined;
        }
    };
    NewClientDeterminationController.prototype.formChecker = function () {
        this.errorCheckerInput = this.newClient.country && (this.newClient.cmrNum || this.newClient.fuzzySearch);
    };
    NewClientDeterminationController.prototype.doSearch = function (opp) {
        this.newClient.ds = 'NC';
        this.newClient.opp = opp;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getFuzzyResults',
                script: '/detail/eligibility/eligibility',
                data: this.newClient,
                token: this.env.user.token,
                bID: this.topic.topicBrowserID,
                partial: true
            }
        });
    };
    NewClientDeterminationController.prototype.changeEditMode = function (action, event) {
        var _this = this;
        if (action === 'save') {
            if (typeof this.topic.topic.nc.ncDecision === 'undefined') {
                this.saveNewClientDecision('initilazed');
            }
            else {
                var items = {
                    message: 'Please justify the new client determination override:',
                    okMessage: 'OK',
                    cancelMessage: 'Cancel',
                    dialogName: 'New Client Override',
                    addCancel: false
                };
                this.Dialog.updateValidForm(event, items, 'confirm-and-comment.html').then(function (dResult) {
                    if (dResult.confirm && dResult.comment && dResult.comment.trim() !== '') {
                        _this.saveNewClientDecision(dResult.comment);
                    }
                });
            }
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.topic.temp[this.comp] = this.topic.topic[this.comp]; //Reset to original value
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    NewClientDeterminationController.prototype.saveNewClientDecision = function (comment) {
        if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
            // Prepare data to be saved
            this.topic.temp.nc.manual = true;
            var updateObject = {
                data: (_a = {},
                    _a['comments.nc'] = {
                        push: true,
                        data: [{
                                comment: 'New Client determinations changed to: ' + this.topic.temp.nc.ncDecision + '; ' + comment,
                                user: this.env.user.email
                            }]
                    },
                    _a.nc = {
                        add: true,
                        data: this.topic.temp.nc
                    },
                    _a
                ),
                id: this.topic.topic._id,
                type: ['comments', 'nc']
            };
            var check = [{
                    id: this.topic.topic._id.substring(4),
                    name: 'NC',
                    value: this.topic.temp.nc
                }];
            this.topic.updateServerTopic('couchUpdate', updateObject, true, check); // Send it to be saved
            this.edit.editMode = this.topic.cancelEdit(this.comp); // Turn edit off
        }
        var _a;
    };
    NewClientDeterminationController.prototype.getNewClientApplicabilityEndData = function () {
        var minEndDate = '';
        //if the temp topic is not presented to check NC decision from the persistent topic
        var nc = this.topic.temp.nc || this.topic.topic.nc;
        if (nc && nc.ncDecision) {
            if (this.getNewUIInfo.NC && this.getNewUIInfo.NC.data && Number(this.getNewUIInfo.NC.data.minNcApprovedEndDate) > 0) {
                minEndDate = this.getNewUIInfo.NC.data.minNcApprovedEndDate;
            }
            else if (Number(this.topic.topic.gpp[0].svisubmitdate) > 0) {
                minEndDate = this.moment(Number(this.topic.topic.gpp[0].svisubmitdate)).add(1, 'years').valueOf();
            }
        }
        return minEndDate;
    };
    /**
     * Determine for v3 is section(Is New Client) can be disabled
     * @private
     * @returns {boolean}
     * @memberof NewClientDeterminationController
     */
    NewClientDeterminationController.prototype.isNewClientV3Disabled = function () {
        var _this = this;
        var isNcCopied = function () {
            return typeof _.get(_this.topic.topic, 'dispute_details.copiedChecks.isNcCopied') === 'boolean'
                ? !_.get(_this.topic.topic, 'dispute_details.copiedChecks.isNcCopied')
                : undefined;
        };
        // If Dispute && NC was not copied
        if (this.topic.topic._id.includes('DIS') && isNcCopied()) {
            return false;
        }
        return !this.getNewUIInfo.NC.isError;
    };
    NewClientDeterminationController.$inject = ['topic', '$state', 'settings', '$stateParams', 'DTS', 'socket', '$scope', 'env', 'Dialog', 'moment'];
    return NewClientDeterminationController;
}());
var NewClientDeterminationComponent = (function () {
    function NewClientDeterminationComponent() {
        this.templateUrl = 'detail-new-client.html';
        this.controllerAs = 'vm';
        this.controller = NewClientDeterminationController;
    }
    return NewClientDeterminationComponent;
}());
angular
    .module('application')
    .component('newClientDetermination', new NewClientDeterminationComponent());

//# sourceMappingURL=detail.eligibility.new.client.component.js.map
